import { Box, Button, Grid, Stack, Typography } from '@mui/material';

import ViaServiceCardItem from './ViaServiceCardItem';
import Iconify from 'components/iconify';
import { IViaServiceItem } from '../../../../@types/service';
import uuidv4 from 'utils/uuidv4';
import { useState } from 'react';

export interface IViaServiceProps {
  viaServices: IViaServiceItem[];
  onChange: (items: IViaServiceItem[]) => void;
}

export default function ViaService({ viaServices, onChange }: IViaServiceProps) {
  const [vias, setVias] = useState<IViaServiceItem[]>(viaServices);

  const handleChangeItem = (index: number, data: IViaServiceItem) => {
    const newArr = vias;
    newArr[index] = data;
    setVias(newArr);
  };

  const handleSave = () => {
    onChange(vias);
  };

  const handleAddNew = () => {
    const newVias = vias;
    newVias.push({ service: '', server: '' });
    setVias(newVias);
    onChange(newVias);
  };

  return (
    <Box sx={{ border: (t) => `1px solid ${t.palette.primary.main}`, borderRadius: 1, p: 1 }}>
      <Stack direction="row" alignItems="center" spacing={1} justifyContent="space-between">
        <Button
          variant="contained"
          size="small"
          startIcon={<Iconify icon="gridicons:add-outline" />}
          sx={{ width: 100 }}
          onClick={handleAddNew}
        >
          Thêm
        </Button>
        <Typography>Thêm danh mục VIA từ nhà cung cấp</Typography>
        <Button
          variant="contained"
          size="small"
          startIcon={<Iconify icon="fluent:save-28-regular" />}
          sx={{ width: 100 }}
          onClick={handleSave}
        >
          Lưu
        </Button>
      </Stack>
      <Grid container spacing={1}>
        {viaServices.map((via, index) => (
          <Grid key={uuidv4()} item xs={12} md={6} lg={6}>
            <ViaServiceCardItem item={via} onChange={(e) => handleChangeItem(index, e)} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
